import { PAGE_SEO } from './pageSeoConfig';

export const ROOM_TYPE_PAGES = {
  'living-room': {
    roomType: 'Living Room',
    title: PAGE_SEO['/room-types/living-room'].title,
    description: PAGE_SEO['/room-types/living-room'].description,
    h1: PAGE_SEO['/room-types/living-room'].h1,
    keywords: 'AI living room design, living room redesign ideas, interior design generator, living room makeover',
    gallerySlug: 'ai-living-room-gallery',
    styles: ['Modern', 'Scandinavian', 'Bohemian', 'Coastal', 'Industrial'],
  },
  bedroom: {
    roomType: 'Bedroom',
    title: PAGE_SEO['/room-types/bedroom'].title,
    description: PAGE_SEO['/room-types/bedroom'].description,
    h1: PAGE_SEO['/room-types/bedroom'].h1,
    keywords: 'AI bedroom design, bedroom redesign ideas, bedroom makeover generator, bedroom interior design',
    gallerySlug: 'ai-bedroom-gallery',
    styles: ['Minimalist', 'Modern', 'Cozy', 'Luxury', 'Japandi'],
  },
  kitchen: {
    roomType: 'Kitchen',
    title: PAGE_SEO['/room-types/kitchen'].title,
    description: PAGE_SEO['/room-types/kitchen'].description,
    h1: PAGE_SEO['/room-types/kitchen'].h1,
    keywords: 'AI kitchen design, kitchen redesign ideas, kitchen makeover, modern kitchen generator',
    gallerySlug: 'ai-kitchen-gallery',
    styles: ['Modern', 'Minimalist', 'Scandinavian', 'Industrial', 'Classic'],
  },
  office: {
    roomType: 'Office',
    title: PAGE_SEO['/room-types/office'].title,
    description: PAGE_SEO['/room-types/office'].description,
    h1: PAGE_SEO['/room-types/office'].h1,
    keywords: 'AI home office design, office redesign ideas, home office makeover, productive workspace design',
    gallerySlug: null,
    styles: ['Modern', 'Industrial', 'Minimalist', 'Scandinavian'],
  },
};

export const GALLERY_HUB = {
  name: 'AI Design Galleries',
  title: 'AI Interior & Home Design Gallery | MyRoomsAI',
  description:
    'Explore MyRoomsAI design galleries for AI room decoration, furniture changes, exterior renovation, garden design, floor plan to 3D, floor plan to room images, and AI floor plan design inspiration.',
  keywords:
    'AI design galleries, AI room design, AI interior design, AI room decorator, furniture changer, AI exterior design, AI garden design, floor plan to 3D, floor plan to room image, floor plan creator, floor plan designer, MyRoomsAI',
  path: '/gallery/',
};

export const GALLERY_PAGES = {
  'ai-living-room-gallery': {
    name: 'AI Living Room Design Gallery',
    title: 'AI Living Room Design Gallery | MyRoomsAI',
    description:
      'Explore AI living room design examples created with MyRoomsAI. See generated living room ideas, layouts, colors, furniture styles, and room makeover inspiration.',
    keywords: 'ai living room gallery, ai living room design, ai generated living rooms, living room design from photo, ai living room makeover',
    roomTypeSlug: 'living-room',
  },
  'ai-bedroom-gallery': {
    name: 'AI Bedroom Design Gallery',
    title: 'AI Bedroom Design Gallery | MyRoomsAI',
    description:
      'Explore AI generated bedroom designs, room decoration ideas, and room design styles. Use MyRoomsAI as your AI room decorator and create your own bedroom design from a photo.',
    keywords:
      'ai bedroom gallery, bedroom designs, room designs, room decoration, ai room decorator, ai generated bedroom, bedroom ai, room design styles, myroomdesigner ai, my ai room designer',
    roomTypeSlug: 'bedroom',
  },
  'ai-kitchen-gallery': {
    name: 'AI Kitchen Design Gallery',
    title: 'AI Kitchen Design Gallery | MyRoomsAI',
    description:
      'Explore AI kitchen design examples created with MyRoomsAI. See generated kitchen ideas, cabinet styles, layouts, colors, lighting, and remodeling inspiration.',
    keywords: 'ai kitchen gallery, ai kitchen design, ai generated kitchens, kitchen design from photo, ai kitchen makeover',
    roomTypeSlug: 'kitchen',
  },
};
